import React from "react";

/** Small pill toggle for translation version */
export default function VersionToggle({ value, onChange }) {
    return (
        <div
            data-testid="version-toggle"
            role="group"
            aria-label="Translation"
            className="inline-flex bg-sage-paper rounded-full p-0.5 border border-ink-10"
        >
            {["kjv", "web"].map((v) => (
                <button
                    key={v}
                    data-testid={`version-${v}`}
                    onClick={() => onChange(v)}
                    className={
                        "px-2.5 py-1 rounded-full font-ui text-[10px] uppercase tracking-[0.15em] font-semibold transition " +
                        (value === v
                            ? "bg-moss text-white shadow-sm"
                            : "text-ink-70 hover:text-ink")
                    }
                    aria-pressed={value === v}
                >
                    {v}
                </button>
            ))}
        </div>
    );
}
